import { ParseAdapter } from "../abstract/ParseAdapter";

export class TchekUser {
  companyPtr: any;
  devicePtr: string;
  devicePtrIPMachine: string;
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  canDetection: boolean;
  canEdit: boolean;
  canAnnotate: boolean;
  canShare: boolean;
  canFilter: boolean;
  canState: boolean;
  constructor() { }
}

export class UserParse extends ParseAdapter {
  constructor(parseObject: Parse.Object) {
    super(parseObject);
  }

  get username(): string { return this.parseObject.get('username'); }
  set username(value: string) { this.parseObject.set('username', value); }

  get canAnnotate(): boolean { return this.parseObject.get('canAnnotate'); }
  set canAnnotate(value: boolean) { this.parseObject.set('canAnnotate', value); }
}

export class User {
  firstName: string;
  lastName: string;
  username: string;
  password: string;

  constructor(
    username: string,
    password: string,
    firstName: string,
    lastName: string
  ) {
    this.username = username;
    this.password = password;
    this.firstName = firstName;
    this.lastName = lastName;
  }
}

export class BackendUserModel {
  id: number;
  identifier: string;
  password: string;
  address: string;

  constructor(
    id: number,
    identifier: string,
    password: string,
    address: string
  ) {
    this.id = id;
    this.identifier = identifier;
    this.password = password;
    this.address = address;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/user.ts